/**
 * Escala de exibição: o motor conta em unidades pequenas (2.000 de dinheiro inicial) e a tela mostra
 * tudo na casa dos milhares, em contos, separando os milhares com espaço como no Business Tour:
 * 150 vira "150 000 contos" (150 mil contos).
 */
export const MONEY_SCALE = 1000;
export const CURRENCY = 'contos';

/** Espaço que não quebra a linha (o número nunca se parte no meio). */
const SP = ' ';
const nf2 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

function groups(v: number): string {
  return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, SP);
}

/** Valor completo, para frases e botões: "150 000 contos". */
export function money(n: number): string {
  const sign = n < 0 ? '−' : '';
  return `${sign}${groups(Math.abs(Math.round(n)) * MONEY_SCALE)}${SP}${CURRENCY}`;
}

/** Só o número, para os placares: "1 575 000". */
export function moneyNumber(n: number): string {
  const sign = n < 0 ? '−' : '';
  return `${sign}${groups(Math.abs(Math.round(n)) * MONEY_SCALE)}`;
}

/** Curto, para as casas do tabuleiro: "150 mil", "1,2 mi". */
export function moneyShort(n: number): string {
  const { value, unit } = moneyParts(n);
  return `${n < 0 ? '−' : ''}${value}${SP}${unit}`;
}

/** Número e unidade separados: { value: '150', unit: 'mil' }. */
export function moneyParts(n: number): { value: string; unit: string } {
  const v = Math.abs(Math.round(n)) * MONEY_SCALE;
  if (v >= 1_000_000) return { value: nf2.format(v / 1_000_000), unit: 'mi' };
  return { value: groups(v / 1000), unit: 'mil' };
}

export function clock(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
